module.exports = __webpack_public_path__ + "img/Gemini.1330dabb.svg";